import { Outlet, RouteObject } from "react-router-dom";

export const loginRoutes: RouteObject[] = [
  {
    element: <Outlet />,
    children: [
      {
        index: true,
        lazy: async () => {
          const { Login } = await import("./login");
          return { element: <Login /> };
        },
      },
    ],
  },
];
